module.exports = __webpack_public_path__ + "static/vlock-06f74773761a835723604252eee79a5e.png";